/**
 * SKU表单 - 物流信息（舒适布局版）
 * 职责: 包装尺寸、重量、海关编码、材质
 */

import React from 'react';
import { Form, InputNumber, Select, Input, Checkbox, Row, Col, Space, Divider } from 'antd';

const { Option } = Select;

export const SKUFormLogisticsFields: React.FC = () => {
    return (
        <div style={{ marginTop: 12 }}>
            <Row gutter={16}>
                <Col span={10}>
                    <Form.Item label="包装尺寸 (cm: 长x宽x高)" style={{ marginBottom: 12 }}>
                        <Space.Compact style={{ width: '100%' }}>
                            <Form.Item name="length" noStyle>
                                <InputNumber style={{ width: '30%' }} placeholder="长" precision={1} min={0} controls={false} />
                            </Form.Item>
                            <Input style={{ width: '5%', borderLeft: 0, pointerEvents: 'none', backgroundColor: '#fff', textAlign: 'center', padding: 0 }} placeholder="x" disabled />
                            <Form.Item name="width" noStyle>
                                <InputNumber style={{ width: '30%' }} placeholder="宽" precision={1} min={0} controls={false} />
                            </Form.Item>
                            <Input style={{ width: '5%', borderLeft: 0, pointerEvents: 'none', backgroundColor: '#fff', textAlign: 'center', padding: 0 }} placeholder="x" disabled />
                            <Form.Item name="height" noStyle>
                                <InputNumber style={{ width: '30%' }} placeholder="高" precision={1} min={0} controls={false} />
                            </Form.Item>
                        </Space.Compact>
                    </Form.Item>
                </Col>
                <Col span={3}>
                    <Form.Item label="体积重(kg)" style={{ marginBottom: 12 }}>
                        <Form.Item
                            shouldUpdate={(prev, curr) =>
                                prev.length !== curr.length ||
                                prev.width !== curr.width ||
                                prev.height !== curr.height
                            }
                            noStyle
                        >
                            {({ getFieldValue }) => {
                                const l = getFieldValue('length') || 0;
                                const w = getFieldValue('width') || 0;
                                const h = getFieldValue('height') || 0;
                                const volWeight = (l * w * h) / 6000;
                                return (
                                    <InputNumber
                                        style={{ width: '100%', color: '#666', backgroundColor: '#f5f5f5' }}
                                        value={volWeight}
                                        precision={2}
                                        readOnly
                                        bordered={false}
                                    />
                                );
                            }}
                        </Form.Item>
                    </Form.Item>
                </Col>
                <Col span={5}>
                    <Form.Item label="产品重量" style={{ marginBottom: 12 }}>
                        <Space.Compact style={{ width: '100%' }}>
                            <Form.Item name="weight" noStyle>
                                <InputNumber style={{ width: '60%' }} placeholder="重量" precision={3} min={0} />
                            </Form.Item>
                            <Form.Item name="weight_unit" noStyle initialValue="kg">
                                <Select style={{ width: '40%' }}>
                                    <Option value="kg">kg</Option>
                                    <Option value="lb">lb</Option>
                                </Select>
                            </Form.Item>
                        </Space.Compact>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item name="hs_code" label="海关编码" style={{ marginBottom: 12 }}>
                        <Input placeholder="HS Code" />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item name="material" label="主要材质" style={{ marginBottom: 12 }}>
                        <Input placeholder="例如：ABS塑料、不锈钢..." />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="特殊属性" style={{ marginBottom: 12 }}>
                        <Form.Item name="has_battery" valuePropName="checked" noStyle>
                            <Checkbox>含电池</Checkbox>
                        </Form.Item>
                        <Form.Item name="is_fragile" valuePropName="checked" noStyle>
                            <Checkbox style={{ marginLeft: 16 }}>易碎品</Checkbox>
                        </Form.Item>
                        <Form.Item name="has_magnet" valuePropName="checked" noStyle>
                            <Checkbox style={{ marginLeft: 16 }}>含磁性</Checkbox>
                        </Form.Item>
                    </Form.Item>
                </Col>
            </Row>
        </div>
    );
};
